module.exports = __webpack_public_path__ + "static/media/Health.ed7aef08.png";